import React, { useMemo } from "react";
import { AsyncPaginate } from "react-select-async-paginate";

const sanitizeValue = (val, isMulti) => {
    if (isMulti) {
        if (!Array.isArray(val)) return [];
        return val.filter(
            (v) =>
                v &&
                typeof v === "object" &&
                v.value !== undefined &&
                v.label !== undefined
        );
    } else {
        if (Array.isArray(val)) return val[0] || null;
        if (val && typeof val === "object" && val.value !== undefined) return val;
        return null;
    }
};

const SupplierSelect = ({
    value,
    onChange,
    loadSuppliers,
    isMulti = false,
    placeholder = "Select Supplier",
    onAddSupplier,
    ...props
}) => {
    const safeValue = useMemo(() => sanitizeValue(value, isMulti), [value, isMulti]);

    return (
        <AsyncPaginate
            {...props}
            isMulti={isMulti}
            value={safeValue}
            loadOptions={async (search, loadedOptions, additional) => {
                const res = await loadSuppliers(search, loadedOptions, additional);
                let options = res?.options || [];

                // ➕ ADD SUPPLIER OPTION
                if (loadedOptions.length === 0 && !options.some(o => o.value === "__ADD_SUPPLIER__")) {
                    options.unshift({
                        value: "__ADD_SUPPLIER__",
                        label: "+ Add Supplier"
                    });
                }

                return {
                    ...res,
                    options
                };
            }}
            onChange={(val) => {
                const selected = sanitizeValue(val, isMulti);
                if (isMulti) {
                    if (selected?.some(v => v.value === "__ADD_SUPPLIER__")) {
                        if (onAddSupplier) onAddSupplier();
                        return;
                    }
                } else {
                    if (selected?.value === "__ADD_SUPPLIER__") {
                        if (onAddSupplier) onAddSupplier();
                        return;
                    }
                }
                onChange(selected);
            }}
            placeholder={placeholder}
            additional={{ page: 1 }}
            menuPortalTarget={document.body}
            styles={{
                menuPortal: base => ({ ...base, zIndex: 9999 }),
                control: (base) => ({
                    ...base,
                })
            }}
        />
    );
};

export default SupplierSelect;
